import axios from "axios";
import React, { FC, useEffect, useState } from "react";
import MainLayout from "src/components/MainLayout";
import { AppConfig } from "src/config/AppConfig";
import { useAppDispatch, useAppSelector } from "src/hooks/redux/hooks";
import "../workers/WorkerCategories.css"
import Swal from "sweetalert2";
import eye from "../../../assets/img/icons/eye-solid.svg"
import "../doorstepServices/DoorstepServices.css"
import { IHelpAndSupport } from "src/helper/interfaces";
import FilterButton from "src/components/layout/FilterButton";
import Cookies from "js-cookie";
import profileIcon from "../../../assets/img/icons/vecteezy_man-empty-avatar-vector-photo-placeholder-for-social_36594092.jpg";
import moment from "moment";
import Paginator from "src/components/layout/Paginator";
import { startLoading, stopLoading } from "src/store/loading/loadingSlice";
import { useBackContext } from "src/hooks/context/BackContext";
import { Link } from "react-router-dom";
import LoadingGif from "src/components/layout/Loader";
import { formatDiffrentDate } from "src/utils/normalFuntions";

interface InitialValuesType {
   _id: string;
   customer_id: string;
   name: string;
   email: string;
   message: string;
   type: string;
   order: number | null;
   user_pic: File | null;
   is_resolved: boolean;
   worker_phone: string;
   createdAt: string;
   worker_pic: File | null;

}

const getAllHelpSupportData = async (token: string, pageNumber: number, pageSize: number, searchValue: string, supportType: string) => {
   // console.log("api: ", supportType)
   return await axios.get(`${AppConfig.DEV_SERVER}/help-support`, {
      headers: {
         "x-access-token": token
      },
      params: {
         page: pageNumber,
         type: supportType,
         search_value: searchValue,
         pageSize
      }
   })
};


const HelpAndSupport = () => {

   const dispatch = useAppDispatch();
   const loading = useAppSelector(state => state?.loading?.value)
   const { setIsBackClicked } = useBackContext();
   const { isBackClicked } = useBackContext();
   const [hideAllFilters, setHideAllFilters] = useState(false);
   const [show, setShow] = useState({
      edit: false,
      create: false,
      view: false
   });

   const selectedOption = useAppSelector((state) => state?.requirementAnsSupport?.supportType?.supportValue);

   const Token = Cookies.get('token');
   const [selectedRequirement, setSelectedRequirement] = useState<InitialValuesType>();
   const [searchVal, setSearchVal] = useState('');
   const [supportData, setSupportData] = useState<any[]>([])
   const [pageNo, setPageNo] = useState(1);
   const [pageSize, setPageSize] = useState(20);
   const [totalPages, setTotalPages] = useState(0);

   useEffect(() => {
      if (!Token) return;
      dispatch(startLoading());
      getAllHelpSupportData(Token as string, pageNo, pageSize, searchVal, selectedOption).then((res) => {
         // console.log(res)
         if (res?.data?.status_code === 200) {
            setSupportData(res?.data?.data?.data);
            setTotalPages(res?.data?.data?.totalPages)
         } else {
            Swal.fire({
               icon: "error",
               title: "Something went wrong!",
               text: `${res?.data?.data?.msg}`,

            });
         }
      }).catch((err) => {
         throw err;
      }).finally(() => {
         dispatch(stopLoading());
      })
   }, [Token, show?.edit, pageNo, pageSize, searchVal, selectedOption])

   //  this below code is for Category name 

   const initialValues: InitialValuesType = {
      _id: "",
      customer_id: "",
      name: "",
      email: "",
      message: "",
      type: "",
      order: null,
      user_pic: null,
      is_resolved: false,
      worker_phone: "",
      createdAt: "",
      worker_pic: null

   };

   // const [inputs, setInputs] = useState(initialValues);

   // const clickOnEdit = (id: string) => {
   //    const requirementToEdit = supportData.find((support) => support._id === id);
   //    setSelectedRequirement(requirementToEdit);
   //    // console.log(servicToEdit)
   //    setShow({
   //       ...show,
   //       edit: true
   //    })
   // }

   const clickOnShow = (id: string) => {
      const requirementToEdit = supportData.find((support) => support._id === id);
      setSelectedRequirement(requirementToEdit);
      setHideAllFilters(true);
      setIsBackClicked(false);
      // console.log(servicToEdit)
      setShow({
         ...show,
         view: true
      })
   }

   const resolveRequest = async (id: string, email: string) => {
      try {
         dispatch(startLoading());
         Swal.fire({
            title: 'Resolve This Ticket?',
            text: "You cant't revert this!",
            icon: 'warning',
            html: `<p>You can, 
        <a href="mailto:${email}" target="_blank">click here to email the user</a> or simply click "Yes, Resolve it!" to proceed.</p>
    `,
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, Resolve it!'
         }).then(async (response) => {
            if (response.isConfirmed) {
               // console.log("lamao")
               await axios.put(`${AppConfig.DEV_SERVER}/help-support/${id}`, null, {
                  headers: {
                     // 'content-type': 'application/json',
                     "X-Access-Token": Token
                  }
               }).then((res) => {
                  // console.log("res: ", res?.data)
                  if (res?.data?.status_code !== 200) {
                     Swal.fire({
                        position: "center",
                        icon: "error",
                        title: "Error..!",
                        text: `${res?.data?.msg}`,
                        showConfirmButton: false,
                        timer: 3000
                     });
                     dispatch(stopLoading());
                  }
                  else if (res?.data?.status_code === 200) {
                     setTimeout(() => {

                        Swal.fire({
                           position: "center",
                           icon: "success",
                           title: "Successfull !!",
                           text: res?.data?.msg,
                           showConfirmButton: false,
                           timer: 2000
                        })

                        dispatch(stopLoading());
                        getAllHelpSupportData(Token as string, pageNo, pageSize, searchVal, selectedOption).then((res) => {
                           // console.log(res)
                           if (res?.data?.status_code === 200) {
                              setSupportData(res?.data?.data?.data);
                              setTotalPages(res?.data?.data?.totalPages)
                           } else {
                              Swal.fire({
                                 icon: "error",
                                 title: "Oops...",
                                 text: `${res?.data?.data?.msg}`,
                                 footer: '<a href="#">Why do I have this issue?</a>'
                              });
                           }
                        })
                     }, 1000 * 2);

                  }
               }).catch((err) => {
                  dispatch(startLoading());
                  console.log(err)
               })  // Clear the selectedFoodItem state after updating
               // setModalShow(false);
            }
            else {
               dispatch(stopLoading());
            }
         }
         ).catch((error: any) => {
            dispatch(stopLoading());
            console.log(error)
         })
         // console.log('Response data:', response.data);
      } catch (error: any) {
         dispatch(stopLoading());
         console.error('Error making POST request:', error.response ? error.response.data : error.message);
      }
   }

   // useEffect(() => {
   //    console.log("loading: ", loading)
   // }, [resolveRequest]);

   const istDate = moment(selectedRequirement?.createdAt).tz('Asia/Kolkata').format('DD-MM-YYYY hh:mm A');
   const clearSearchValue = () => {
      setSearchVal("");  // Clear the search input
   };
   useEffect(() => {
      if (isBackClicked) {
         setHideAllFilters(!isBackClicked)
      }
   }, [isBackClicked]);

   const handlePageSizeChange = (e: any) => {
      setPageSize(e?.target?.value)
   }

   return (
      <MainLayout
         showAllFilters={hideAllFilters}
         searchValue={searchVal}
         onChange={(e) => setSearchVal(e.target.value)}
         clearValChange={clearSearchValue}
      >
         <div className="mt-3 mb-3">
            {
               loading ?
                  <div>
                     <LoadingGif />
                  </div>
                  : ""
            }
            <div className="card category-main me-2 p-md-4">
               <div>
                  <div className="d-flex justify-content-end mb-2">

                     <div className="d-flex justify-content-end gap-4 w-40">
                        <div className="d-flex gap-2">
                           <span className="d-flex align-items-center pagesize-text">
                              PageSize
                           </span>

                           <select
                              className="form-select"
                              style={{ backgroundPosition: "right 5px center", width: "60px" }}
                              aria-label="Default select example"
                              value={pageSize} // Bind the value to the state
                              onChange={handlePageSizeChange} // Handle the change
                           >
                              <option value={20}>20</option>
                              <option value={50}>50</option>
                              <option value={100}>100</option>
                              <option value={200}>200</option>
                           </select>
                        </div>

                        <FilterButton
                           name={selectedOption}
                           type="support"
                           options={["Worker", "User"]}

                        />
                        {/* <SearchBar width="50%" value={searchValue} onInputChange={(e) => setSearchValue(e?.target?.value)} /> */}
                     </div>

                  </div>
                  <div className="table-extra-responsive">

                     <table className="table table-striped card-body">
                        <thead>
                           <tr style={{
                              backgroundColor: "#495057", color: "white"
                           }}>
                              <th scope="col" className="text-start ps-4">Sr.No. </th>
                              <th scope="col" className="text-start ps-4">Profile Pic </th>
                              <th scope="col-2" className="text-start ps-4">Customer Name</th>
                              <th scope="col-2" className="text-start ps-4">Support Id </th>
                              <th scope="col" className="text-start ps-4">Email</th>
                              <th scope="col" className="text-start ps-4">Phone No.</th>
                              <th scope="col" className="text-start ps-4">Resolved</th>
                              {
                                 selectedOption !== "User" ?
                                    <th scope="col" className="text-start ps-4">Priority</th>
                                    : ""
                              }
                              <th scope="col" className="text-start ps-4">Date</th>
                              <th scope="col" className="col-lg-2 cat_btns">Action</th>
                           </tr>
                        </thead>
                        <tbody>
                           {
                              supportData && supportData?.map((data: IHelpAndSupport, i) => {
                                 const rowNumber = (pageNo - 1) * pageSize + (i + 1);
                                 const date = formatDiffrentDate(data?.createdAt);
                                 return (
                                    <tr key={data?._id}>
                                       <td className="text-start align-content-center ps-4">
                                          <span className="">
                                             {rowNumber}
                                          </span>

                                       </td>

                                       <td className="text-start align-content-center ps-4 ">
                                          {data?.type !== "user" ? (
                                             data?.worker_pic ? (
                                                <img src={data?.worker_pic} alt="profile-pic" className="profile-pic" />
                                             ) : (
                                                <span className="d-flex align-items-center">
                                                   <img src={profileIcon} alt="profileIcon" className="profile-pic" />
                                                </span>
                                             )
                                          ) : (
                                             data?.user_pic ? (
                                                <img src={data?.user_pic} alt="profile-pic" className="profile-pic" />
                                             ) : (
                                                <span className="d-flex align-items-center">
                                                   <img src={profileIcon} alt="profileIcon" className="profile-pic" />
                                                </span>
                                             )
                                          )}
                                       </td>

                                       <td className="text-start align-content-center ps-4">
                                          <span className="">
                                             {data?.name}
                                          </span>

                                       </td>

                                       <td className="icon-td align-content-center text-start ps-4">
                                          {data?._id}
                                       </td>
                                       <td className="icon-td align-content-center text-start ps-4">
                                          {data?.email}
                                       </td>
                                       <td className="icon-td align-content-center text-start ps-4">
                                          {data?.type !== "user" ? data?.worker_phone : data?.user_phone}
                                       </td>
                                       <td className="icon-td align-content-center text-start ps-4">
                                          {data?.is_resolved ? "Yes" : "No"}
                                       </td>
                                       {
                                          data?.type !== "user" ?
                                             <td className="icon-td align-content-center text-start ps-4">
                                                {data?.order === 1 ? "Premium" : data?.order === 2 ? "Priority " : data?.order === 3 ? "Standard " : "Basic "}
                                             </td> :
                                             ""
                                       }

                                       <td className="icon-td align-content-center text-start ps-4">
                                          {date?.formattedDate}, <br />
                                          {date?.formattedHours}
                                       </td>
                                       <td className="align-content-center ">
                                          <div className="d-flex justify-content-center gap-3">
                                             <Link to={`/support/${data?._id}`}>
                                                <button className="btn btn-sm delete_btn " onClick={() => clickOnShow(data?._id)}>
                                                   <img src={eye} />
                                                </button>
                                             </Link>

                                             <div className="d-flex justify content-center align-items-center">
                                                <button className={`btn  ${data?.is_resolved ? "btn-primary" : "btn-success"} btn-sm resolve-btn`}
                                                   onClick={() => {
                                                      data?.is_resolved ? console.log(data?.is_resolved) :
                                                         resolveRequest(data?._id, data?.email)
                                                   }}>
                                                   {data?.is_resolved ? "Resolved" : "Resolve"}

                                                </button>
                                             </div>

                                          </div>

                                       </td>
                                    </tr>
                                 )
                              }
                              )
                           }

                        </tbody>
                     </table>


                  </div>

                  <Paginator
                     totalPages={totalPages}
                     pageNo={pageNo}
                     onPageChange={(e, no) => setPageNo(no)}
                     alignment="right"
                  />
               </div>


            </div>

         </div>

      </MainLayout >
   )

};



export default HelpAndSupport;